import type { ComponentSchema } from '../../../../../schema-types'

/** Grey band, then up to 4 products side by side: price, brand, warranty, category, rating and every specification. */
export const schema: ComponentSchema = {
  type: 'compare',
  label: 'Compare',
  description: 'Up to four saved products side by side (photo, price, brand, warranty, specifications), or an empty state.',
  supportedPages: ['compare'],
  variants: [{ id: 'v1', label: 'Side by side' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Compare products' },
    { key: 'emptyTitle', label: 'Empty title', type: 'string' },
    { key: 'emptyText', label: 'Empty message', type: 'string' },
  ],
}
